import logoAD from '@/assets/logos/nuevo.svg';
import { BRAND } from '../utils';

export const MarcaAD = () => (
  <a
    href="https://app.almacenesdigitales.cl"
    target="_blank"
    rel="noopener noreferrer"
    className="flex items-center gap-1 hover:opacity-70 transition-opacity"
    aria-label="Impulsado por Almacenes Digitales"
  >
    <span className="text-[10px] text-gray-400 leading-none">por</span>
    <img src={logoAD} alt="" aria-hidden="true" className="h-3.5" />
    <span className="text-[10px] font-bold leading-none" style={{ color: BRAND.navy }}>
      ALMACENES<span style={{ color: BRAND.cyan }}>digitales</span>
    </span>
  </a>
);
